import useAgent from "../../../library/hooks/useAgent";
import { agentBaseUrl, agentFactoryConfig } from "../../../library/agents/agentConfig";
/**
 * Hook for the EscalationTypeRecommenderAgent.
 *
 * Returns a binary recommendation: zero or one recommended escalation type.
 * Output Format: JSON with `{ masterList, recommendedTypes, summary }`
 */
export const useEscalationTypeRecommenderAgent = () => useAgent({
    agentUrl: `${agentBaseUrl}/api/agents/EscalationTypeRecommenderAgent`,
    factoryConfig: agentFactoryConfig,
});
